import React, { useContext } from 'react'
import FlexView from 'react-flexview/lib'
import { Grid, TextField, useMediaQuery } from '@material-ui/core'
import { PasswordInput } from '../Core/PasswordInput'
import { useForm } from 'react-hook-form'
import NewFillButton from '../Core/NewFillButton'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import AccountApi from '../../api/account.api'
import { awaitWithLoading } from '../../services/utils'
import { EMAIL_REGEX } from '../../Constants'
import { SessionService } from '../../services/SessionService'
import SessionContext, { SessionContextStore } from '../../context/SessionContext'
import { useHistory } from 'react-router-dom'
var classNames = require('classnames')

export const ChangeEmail = () => {
    const sessionContext = useContext(SessionContextStore)
    const { register, triggerValidation, errors, getValues } = useForm({mode: 'onChange'})
    const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'));
    const history = useHistory()
    const onUserChangeEmail = async () => {
        await sessionContext.logout()
        history.push('/login')
    }
    


    const changeEmail = async () => {
        let valid = await triggerValidation()
        if(!valid) return
        
        let res = undefined
        if(SessionService.isAdmin()) 
            res = await awaitWithLoading(AccountApi.changeEmailAdmin(getValues()['new_email'], getValues()['confirmed_email']))
        else
            res = await awaitWithLoading(AccountApi.changeEmail(getValues()['new_email'], getValues()['confirmed_email'], getValues()['password']))
            
        if(res && res.ok) {
            if(SessionService.isAdmin()){
            EventEmitterService.dispatch(EventKey.ShowSuccess, {
                title: "Email changed!",
                body: 'Email changed successfully',
                onClose: val => {
                history.goBack()
                },
          })
        }else{
            EventEmitterService.dispatch(EventKey.ShowSuccess, {
                title: "We've sent a confirmation email!",
                body: 'Check your new email and confirm. then login with your new credentials',
                onClose: val  => {
                    onUserChangeEmail()
                },
          })


          }

        }
        else
            EventEmitterService.dispatch(EventKey.ShowError, res)
    }
    return (
        <>
        <Grid container spacing={3}>
            <Grid item xs={12} md>
                <TextField fullWidth variant="outlined" className="margin-top-basic" label="New Email" type="email" name="new_email" inputRef={register({required: true, pattern: { value: EMAIL_REGEX, message: "Invalid email address"}})} helperText={!!errors.new_email && (errors.new_email.message || errors.new_email.type)} error={!!errors.new_email} />
            </Grid>
            <Grid item xs={12} md>
                <TextField fullWidth variant="outlined" className="margin-top-basic" label="Confirm New Email" type="email" name="confirmed_email" inputRef={register({required: true, validate: {  Match: x => x == getValues()['new_email']},  pattern: { value: EMAIL_REGEX, message: "Invalid email address"}})} helperText={!!errors.confirmed_email && (errors.confirmed_email.message || errors.confirmed_email.type)} error={!!errors.confirmed_email} />
            </Grid>
            {!SessionService.isAdmin() && 
                <Grid item xs md>
                    <PasswordInput fullWidth variant="outlined" className="margin-top-basic" label="Password" name="password" inputRef={register({required: true, minLength: {value: 8, message: 'At least 8 characters'}})} error={!!errors.password || !!errors.confirm_password} helperText={(!!errors.password && (errors.password.message || errors.password.type) || (!!errors.confirm_password && "Passwords do not match"))} />
                </Grid>}
        </Grid>
        <FlexView hAlignContent={isMobile ? 'center' : 'left'} className={classNames({"fit-content": !isMobile})}>
            <NewFillButton onClick={changeEmail}>Update Email</NewFillButton>
        </FlexView>
        </>
    )
}